import { createStore } from 'vuex';
import { isLoggedIn, logIn, logOut } from "../utils/auth";
import api from "../api";
import router from "../router";

export default createStore({
  state: {
    user: null,
    branches: [],
    selectedTab: null,
    dynamicBreadcrumbLabels: {},
    cart: {
      products: []
    },
    snack: null,
  },
  getters: {
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },

    setBranches(state, payload) {
      state.branches = payload;
    },

    setSelectedTab(state, payload) {
      state.selectedTab = payload;
    },

    setSnack(state, payload) {
      state.snack = payload;
      setTimeout(() => (state.snack = null), 3000);
    },

    setBreadcrumbLabel(state, { routeName, label }) {
      state.dynamicBreadcrumbLabels = {
        ...state.dynamicBreadcrumbLabels,
        [routeName]: label,
      };
    },

    clearBreadcrumbLabels(state) {
      state.dynamicBreadcrumbLabels = {};
    },

    setCart(state, payload) {
      state.cart = payload;
    },

    addToCart(state, payload) {
      let product = state.cart.products.filter((product) => {
        return (product.id === payload.id);
      })[0];

      if (!product) {
        state.cart.products.push(payload);
      } else {
        product.quantity += payload.quantity;
      }
    },

    removeFromCart(state, payload) {
      state.cart.products = state.cart.products.filter((product) => {
        return !(product.id === payload.id);
      });
    },

    addQuantityToCart(state, id) {
      let product = state.cart.products.filter((product) => {
        return (product.id === id);
      })[0];

      product.quantity += 1;
    },

    subtractQuantityToCart(state, id) {
      let product = state.cart.products.filter((product) => {
        return (product.id === id);
      })[0];

      if (product.quantity === 1) {
        state.cart.products = state.cart.products.filter((product) => {
          return !(product.id === id);
        });
      } else {
        product.quantity -= 1;
      }
    },
  },
  actions: {
    login({ commit, dispatch }, payload) {
      const branches = payload.user.franchise_user.is_super ? payload.user.franchise_user.franchise.branches : payload.user.franchise_user.branches;
      if (branches.length === 0) {
        dispatch(
          "errorSnack",
          "No tienes sucursales asignadas"
        );

        return;
      }

      logIn(payload.token);
      commit("setUser", payload.user);
      commit("setBranches", branches);
      router.push({ name: "dashboard", params: { branchId: branches[0].id } });
    },

    async loadUser({ commit, dispatch }) {
      if (isLoggedIn()) {
        try {
          const user = await api.auth.me();
          commit("setUser", user);
          const branches = user.franchise_user.is_super ? user.franchise_user.franchise.branches : user.franchise_user.branches;
          if (branches.length === 0) {
            router.push({ name: 'login' });
          } else {
            commit("setBranches", branches);
            dispatch("setInitialCart");
          }
        } catch (error) {
          if (error.response && error.response.status !== 401) {
            dispatch("logout");
          }
        }
      }
      return Promise.resolve();
    },

    logout({ commit, dispatch }) {
      commit("setUser", null);
      logOut();
      router.push({ name: 'login' });
    },

    errorSnack({ commit }, payload) {
      commit("setSnack", {
        message: payload,
        type: "error",
      });
    },

    successSnack({ commit }, payload) {
      commit("setSnack", {
        message: payload,
        type: "success",
      });
    },

    setInitialCart({ commit }) {
      const cart = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : { products: [] };
      commit("setCart", cart);
    },

    addToCart({ commit, state, dispatch }, payload) {
      commit('addToCart', payload);
      localStorage.setItem('cart', JSON.stringify(state.cart));
      dispatch('successSnack', 'Producto agregado exitosamente al carrito');
    },

    removeFromCart({ commit, state }, payload) {
      commit('removeFromCart', payload);
      localStorage.setItem('cart', JSON.stringify(state.cart));
    },

    addQuantityToCart({ commit, state }, payload) {
      commit('addQuantityToCart', payload);
      localStorage.setItem('cart', JSON.stringify(state.cart));
    },

    subtractQuantityToCart({ commit, state }, payload) {
      commit('subtractQuantityToCart', payload);
      localStorage.setItem('cart', JSON.stringify(state.cart));
    },

    clearCart({ commit, state }) {
      commit('setCart', { products: [] });
      localStorage.setItem('cart', JSON.stringify(state.cart));
    },
  },
  modules: {
  }
})
